import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  useToast,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useAuth } from '../../../../auth-context/auth.context';
import CustomerApi from '../../../../api/customer';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import { CustomerAdminValidationSchema } from 'formValidations/customerAdminFormValidations';

export default function PopModal(props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const toast = useToast();

  const initialValues = {
    name: '',
    email: '',
    phoneNumber: '',
    status: 'UNVERIFIED',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log('values from Create customer API call', values);
    try {
      const api = await CustomerApi.Create(values);
      console.log('Api data= ', api);
      if (api.data.status_code === 200) {
        toast({
          title: api?.data?.message || 'Successfully Added',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });

        onClose();
        if (props.onSuccess) {
          props.onSuccess(api.data.data);
        }
        if (props.func) {
          props.func();
        }
      } else {
        toast({
          title: api?.data?.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
      toast({
        title: 'Error',
        description: err.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        variant={props.variant || 'lightBrand'}
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        disabled={props.disabled}
        onClick={onOpen}
        leftIcon={props.Icon}
        w={props.w}
        mt={props.mt}
      >
        {props.btnText || props.head}
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={CustomerAdminValidationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form noValidate>
                  <InputField
                    label='Name'
                    name='name'
                    type='text'
                    placeholder='Name'
                    required
                  />
                  <InputField
                    label='Email'
                    name='email'
                    type='email'
                    placeholder='Enter Email'
                    required
                  />
                  <InputField
                    label='Phone Number'
                    name='phoneNumber'
                    type='number'
                    placeholder='Phone Number'
                    required
                  />
                  <SelectField
                    label='Status'
                    name='status'
                    placeholder='Select option'
                    options={props.statusOptions || [
                      { value: 'ACTIVE', label: 'Active' },
                      { value: 'INACTIVE', label: 'Inactive' },
                      { value: 'UNVERIFIED', label: 'Unverified' },
                      { value: 'BLOCKED', label: 'Blocked' },
                    ]}
                    required
                  />
                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'
                      isLoading={isSubmitting}
                    >
                      Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
